const cookieOptions = {
  path: '/',
  domain: process.env.REACT_APP_COOKIE_DOMAIN,
  secure: (process.env.REACT_APP_COOKIE_SECURE || 'true') !== 'false',
  sameSite: true,
  httpOnly: false,
};

export default cookieOptions;
